<template>
  <span>
    <span v-if="propsValue">
      <slot />
    </span>
    <span
      v-else
      class="select-span">请选择{{ tip }}</span>
    <i
      class="el-icon-edit"
      @click="select"></i>
    <i
      v-if="propsValue && clearable"
      class="el-icon-delete"
      @click="clear"
    ></i>
  </span>
</template>

<script>
export default {
  name: 'CustomSelectIcon',
  props: {
    tip: { type: String, default: '考卷' },
    propsValue: { type: [Number, String], default: '' },
    clearable: { type: Boolean, default: false }
  },
  methods: {
    select() {
      this.$emit('select')
    },
    clear() {
      this.$emit('clear')
    }
  }
}
</script>
<style lang="stylus" scoped>
.select-span {
  color: #999;
}

.el-icon-edit {
  cursor: pointer;
  margin-left: 10px;
  color: #409eff;
}

.el-icon-delete {
  cursor: pointer;
  margin-left: 10px;
  color: red;
}
</style>
